<template>
  <el-dialog
    width="1000px"
    :title="editType == 1 ? '新增-配置' : '编辑-配置'"
    :visible.sync="editDocumentShow"
    :before-close="close"
    @open="init"
  >
    <el-form :model="documentForm" ref="documentForm" :rules="rules" label-width="160px" label-position="right" size="small">
      <el-form-item label="名称" prop="configName">
        <el-input v-model="documentForm.configName" placeholder="请输入名称"></el-input>
      </el-form-item>

      <el-form-item label="描述" prop="description">
        <el-input v-model="documentForm.description" type="textarea" :rows="1" autosize maxLength="128" placeholder="请输入描述"></el-input>
      </el-form-item>

      <el-form-item label="配置标识" prop="configKey">
        <el-input class="w300" v-model="documentForm.configKey" placeholder="请输入配置key"></el-input>
      </el-form-item>

      <el-form-item label="分类" prop="category">
        <el-select v-model="documentForm.category" placeholder="请选择分类">
          <el-option label="协议" value="agreement"></el-option>
          <el-option label="常量" value="constant"></el-option>
          <el-option label="参数" value="parameter"></el-option>
          <el-option label="其它" value="other"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="内容数据类型" prop="valueType">
        <el-select v-model="documentForm.valueType" placeholder="请选择内容数据类型" @change="handleValueTypeChange">
          <el-option label="HTML" value="html"></el-option>
          <el-option label="String" value="string"></el-option>
          <el-option label="Number" value="number"></el-option>
          <el-option label="JSON" value="json"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="内容" prop="configValue">
        <Editor v-if="documentForm.valueType == 'html'" v-model="documentForm.configValue" :min-height="200" :max-height="500" />
        <el-input
          v-else-if="documentForm.valueType == 'string'"
          v-model="documentForm.configValue"
          type="textarea"
          :rows="1"
          autosize
          placeholder="请输入内容"
        ></el-input>
        <el-input
          v-else-if="documentForm.valueType == 'number'"
          v-model="documentForm.configValue"
          type="number"
          placeholder="请输入内容"
        ></el-input>
        <div v-else-if="documentForm.valueType == 'json'" id="json-editor-container"></div>
      </el-form-item>

      <el-form-item label="状态" prop="isDisabled">
        <el-radio-group v-model="documentForm.isDisabled">
          <el-radio :label="false">启用</el-radio>
          <el-radio :label="true">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button v-if="editType == 1" type="success" @click="resetForm">重 置</el-button>
      <el-button type="primary" @click="submitForm">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Editor from "@/components/Editor";
import loadMonaco from "@/utils/loadMonaco";
import { getDocumentConfigDetail, createDocumentConfig, updateDocumentConfig } from "@/api/basicConfig";

export default {
  props: ["editDocumentShow", "editType", "id"],
  components: {
    Editor
  },
  data() {
    return {
      documentForm: {
        configName: "",
        description: "",
        configKey: "",
        category: "",
        valueType: "html",
        configValue: "",
        isDisabled: false
      },
      rules: {
        configName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        configKey: [{ required: true, message: "请输入配置标识", trigger: "blur" }],
        category: [{ required: true, message: "请选择分类", trigger: "change" }],
        valueType: [{ required: true, message: "请选择内容数据类型", trigger: "change" }],
        configValue: [{ required: true, message: "请输入内容", trigger: "blur" }],
        isDisabled: [{ required: true, message: "请选择状态", trigger: "change" }]
      },
      monacoEditor: null
    };
  },

  methods: {
    // 初始化
    init() {
      if (this.editType == 2) {
        this.getDocumentDetail();
      }
    },

    // 获取详情
    async getDocumentDetail() {
      try {
        let res = await getDocumentConfigDetail({ id: this.id });
        if (res.code == 200) {
          this.documentForm = res.data || {};
          // 初始化JSON编辑器
          if (this.documentForm.valueType == "json") {
            this.$nextTick(() => {
              this.initJsonEditor();
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.disposeJsonEditor();
      if (this.editType == 2) {
        this.resetForm();
      }
      this.$emit("close");
    },

    // 初始化JSON编辑器
    initJsonEditor() {
      if (this.monacoEditor) {
        this.disposeJsonEditor();
      }
      loadMonaco(monaco => {
        const container = document.getElementById("json-editor-container");
        if (container) {
          this.monacoEditor = monaco.editor.create(container, {
            value: this.documentForm.configValue || "{}",
            language: "json",
            theme: "vs",
            automaticLayout: true,
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            formatOnType: true,
            formatOnPaste: true
          });
          // 监听内容变化
          this.monacoEditor.onDidChangeModelContent(() => {
            this.documentForm.configValue = this.monacoEditor.getValue();
          });
        }
      });
    },

    // 销毁JSON编辑器
    disposeJsonEditor() {
      if (this.monacoEditor) {
        this.monacoEditor.dispose();
        this.monacoEditor = null;
      }
    },

    // 内容数据类型改变时，根据数据类型设置内容输入框的类型
    handleValueTypeChange() {
      this.documentForm.configValue = "";
      if (this.documentForm.valueType === "json") {
        this.$nextTick(() => {
          this.initJsonEditor();
        });
      } else {
        this.disposeJsonEditor();
      }
    },

    // 重置表单
    resetForm() {
      this.$refs["documentForm"].resetFields();
      this.documentForm.valueType = "html";
      this.handleValueTypeChange();
    },

    // 提交表单
    submitForm() {
      this.$refs["documentForm"].validate(valid => {
        if (valid) {
          if (this.documentForm.valueType == "json") {
            this.documentForm.configValue = JSON.stringify(JSON.parse(this.documentForm.configValue));
          }
          // 新增
          if (this.editType == 1) {
            this.createDocumentConfig();
          }
          // 编辑
          else if (this.editType == 2) {
            this.updateDocumentConfig();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 新增配置
    async createDocumentConfig() {
      try {
        this.documentForm.id = null;
        let res = await createDocumentConfig(this.documentForm);
        if (res.code == 200) {
          this.$message({
            message: "新增成功",
            type: "success"
          });
          this.$refs["documentForm"].resetFields();
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 编辑配置
    async updateDocumentConfig() {
      try {
        let res = await updateDocumentConfig(this.documentForm);
        if (res.code == 200) {
          this.$message({
            message: "编辑成功",
            type: "success"
          });
          this.$refs["documentForm"].resetFields();
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.w300 {
  width: 300px;
}

.el-select {
  width: 300px;
}

.dialog-footer {
  text-align: center;
}

#json-editor-container {
  width: 100%;
  min-height: 200px;
  max-height: 500px;
  padding: 10px 10px 10px 0;
  border: 1px solid #e4e7ed;
  border-radius: 5px;
}
</style>
